import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { Clock, AlertTriangle } from 'lucide-react';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', green: '#1D9E75', amber: '#E8A020', red: '#E24B4A' };
const SC = { met: C.green, late: C.amber, pending: C.slate, amber: C.amber, red: C.red, failed: C.red, not_measured: C.slate };
const SL = { met: 'MET', late: 'MET LATE', pending: 'ON TRACK', amber: 'AMBER — ACT NOW', red: 'BREACHED', failed: 'FAILED', not_measured: 'N/M' };

export default function PartFPromisesCard({ api, claimId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/claims/${claimId}/promises`).then(r => setData(r.data)).catch(() => setData(null));
  }, [api, claimId]);
  if (!data || !data.promises?.length) return null;
  return (
    <Card className="rounded-md bg-white p-4" data-testid="part-f-promises-card"
      style={{ border: '1px solid rgba(136,150,168,0.12)', borderLeft: `3px solid ${SC[data.worst] || C.green}` }}>
      <div className="flex items-center gap-2 mb-2">
        <Clock className="w-4 h-4" style={{ color: SC[data.worst] || C.green }} />
        <h3 className="text-xs font-semibold uppercase tracking-wider" style={{ color: C.slate }}>Part F Promises</h3>
        <span className="text-[10px]" style={{ color: C.slate }}>measured against wording v{data.measured_against} · {data.state} business days</span>
      </div>
      {data.late_notification && (
        <div className="flex items-start gap-2 px-3 py-2 rounded-sm mb-2" data-testid="late-notification-flag"
          style={{ background: 'rgba(232,160,32,0.09)', border: '1px solid rgba(232,160,32,0.35)' }}>
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" style={{ color: C.amber }} />
          <p className="text-[11px]" style={{ color: '#7A5210' }}>{data.late_notification.note}</p>
        </div>
      )}
      <div className="space-y-1.5">
        {data.promises.map(p => (
          <div key={p.id} className="flex items-start justify-between gap-2" data-testid={`claim-promise-${p.id}`}>
            <div className="min-w-0">
              <p className="text-xs font-medium truncate" style={{ color: C.navy }}>
                <span className="font-mono text-[10px] mr-1" style={{ color: C.slate }}>{p.id}</span>{p.promise}
              </p>
              <p className="text-[10px]" style={{ color: C.slate }}>
                {p.deadline ? `due ${new Date(p.deadline).toLocaleString('en-AU', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}` : ''}
                {p.met_at ? ` · done ${new Date(p.met_at).toLocaleString('en-AU', { day: '2-digit', month: 'short' })}` : ''}
                {p.detail ? ` · ${p.detail}` : ''}
                {p.blocked_on && !p.wired ? ` · blocked: ${p.blocked_on.split('—')[0].trim()}` : ''}
              </p>
            </div>
            <span className="px-2 py-0.5 rounded text-[10px] font-bold shrink-0"
              style={{ background: (SC[p.status] || C.slate) + '15', color: SC[p.status] || C.slate }}>
              {SL[p.status] || p.status}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}
